/**
 * @generated SignedSource<<c566dfaf5b91bdd4e863c3e0cdfdfc6b>>
 * @relayHash d2c22f23525602a4dba9bafe52d8a616
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 790d14048d2d6a450b231be84229a5797938a8df2b777a330a0ddc23b9235bf8

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { JourneyConfigurationPageQuery } from './JourneyConfigurationPageQuery.graphql';

import isConditionsFGEnabled_provider from '@atlassian/jira-relay-provider/src/jira-journey-builder-parent-trigger-conditions.relayprovider';
import isTemplateAnalyticsEnabled_provider from '@atlassian/jira-relay-provider/src/journey-builder-template-analytics-fe.relayprovider';
import isJbRovoIntegrationEnabled_provider from '@atlassian/jira-relay-provider/src/jsm-journey-builder-rovo-integration.relayprovider';

const node: PreloadableConcreteRequest<JourneyConfigurationPageQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "790d14048d2d6a450b231be84229a5797938a8df2b777a330a0ddc23b9235bf8",
    "metadata": {},
    "name": "JourneyConfigurationPageQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcjsmjourneybuilderconditionsmartvaluerelayprovider": isConditionsFGEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjsmjourneybuilderrovointegrationrelayprovider": isJbRovoIntegrationEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjirajourneybuilderparenttriggerconditionsrelayprovider": isConditionsFGEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjourneybuildertemplateanalyticsferelayprovider": isTemplateAnalyticsEnabled_provider
    }
  }
};

export default node;
